import { ViewObjectParser } from "../view-object-parser";
import { PlotSettings } from "../../settings/view-objects/plot-settings";
import { DataSourcePlotSettings } from "../../settings/view-objects/plot/data-source-plot-settings";
import { getItemByField, ObjectCreator } from "../../../../../../web-graphics";
import { getSizeSettings } from "../../../utils/get-size-settings";
import { SettingsParser } from "../settings-parser";

export class PlotSettingsParser extends ViewObjectParser {
  constructor(dataSourceParser, plotContentParserMap) {
    super();
    this.parsedFieldNames.push("title");
    this.parsedFieldNames.push("contentBorders");
    this.parsedFieldNames.push("plotContent");
    this.parsedFieldNames.push("dataSource");
    this.parsedFieldNames.push("dataSources");
    this.parsedFieldNames.push("channels"); // default dataSource field
    this.dataSourceParser = dataSourceParser;
    this.plotContentParserMap = plotContentParserMap;
  }

  static createSettings(settings, defaultSettings, dataSourceParser, plotContentParserMap) {
    let parsedSettings = ViewObjectParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    parsedSettings.title = settings.title; // type: string
    let mergedContentBorders = ObjectCreator.merge(settings.contentBorders, defaultSettings?.contentBorders);
    parsedSettings.contentBorders = {};
    for (const key of Object.getOwnPropertyNames(mergedContentBorders)) {
      parsedSettings.contentBorders[key] = getSizeSettings(mergedContentBorders[key], 0, 0);
    }
    let plotContentNames = [];
    if (settings.plotContent !== undefined && plotContentParserMap !== undefined) {
      parsedSettings.plotContent = {};
      for (let contentIndex = 0; contentIndex < settings.plotContent.length; contentIndex++) {
        let plotContentSettings = settings.plotContent[contentIndex];
        let plotContentParser = plotContentParserMap.get(plotContentSettings.name);
        let defaultPlotContentSettings = getItemByField("name", plotContentSettings.name, defaultSettings?.plotContent);
        if (plotContentSettings.settings === undefined) {
          plotContentSettings.settings = {};
        }
        plotContentSettings.settings._plotSettings = parsedSettings;
        let parsedPlotContent = plotContentParser?.parse(plotContentSettings, defaultPlotContentSettings);
        if (parsedPlotContent !== undefined) {
          plotContentNames.push(plotContentSettings.name);
          let plotContentKey = parsedPlotContent.type != "graphic" ? parsedPlotContent.type : parsedPlotContent.place;
          if (parsedSettings.plotContent[plotContentKey] === undefined) {
            parsedSettings.plotContent[plotContentKey] = [];
          }
          parsedSettings.plotContent[plotContentKey].push(parsedPlotContent);
        }
      }
    }
    if (defaultSettings?.plotContent !== undefined) {
      for (let contentIndex = 0; contentIndex < defaultSettings.plotContent.length; contentIndex++) {
        let defaultContentSettings = defaultSettings.plotContent[contentIndex];
        if (!plotContentNames.includes(defaultContentSettings.name)) {
          let plotContentParser = plotContentParserMap.get(defaultContentSettings.name);
          //defaultContentSettings._plotSettings = parsedSettings;
          let parsedPlotContent = plotContentParser?.parse(
            {
              settings: {
                _plotSettings: parsedSettings
              }
            },
            defaultContentSettings
          );
          if (parsedPlotContent !== undefined) {
            let plotContentKey = parsedPlotContent.type != "graphic" ? parsedPlotContent.type : parsedPlotContent.place;
            if (parsedSettings.plotContent[plotContentKey] === undefined) {
              parsedSettings.plotContent[plotContentKey] = [];
            }
            parsedSettings.plotContent[plotContentKey].push(parsedPlotContent);
          }
        }
      }
    }
    if ((settings.dataSources !== undefined || settings.channels !== undefined) && dataSourceParser !== undefined) {
      let dataSources = [];
      if (settings.channels !== undefined) {
        if (settings.dataSources !== undefined) {
          throw new Error(
            "Visualizator config parser error: tags 'dataSources' and 'channels' don't have to be registered in the same place"
          );
        }
        dataSources.push({
          id_dataSource: 0,
          channels: settings.channels,
          marks: settings.marks
        });
      } else {
        dataSources = settings.dataSources;
      }
      parsedSettings.dataSources = [];
      let defaultDataSourceSettings = defaultSettings?.dataSource;
      for (let dataSourceIndex = 0; dataSourceIndex < dataSources.length; dataSourceIndex++) {
        let parsedDataSourceSettings = dataSourceParser.parse(dataSources[dataSourceIndex], defaultDataSourceSettings);
        parsedSettings.dataSources.push(new DataSourcePlotSettings(parsedDataSourceSettings));
      }
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = PlotSettingsParser.createSettings(settings, defaultSettings, this.dataSourceParser, this.plotContentParserMap);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new PlotSettings(parsedSettings);
  }
}
